import { z } from "zod";

const canonicalRevenuePattern = /^-?\d+(?:\.\d+)?$/;
const groupedRevenuePattern = /^-?\d{1,3}(?:\.\d{3})+(?:,\d+)?$/;
const commaDecimalRevenuePattern = /^-?\d+,\d+$/;

export const formatHubSpotRevenueForInput = (value: string): string =>
  canonicalRevenuePattern.test(value) ? value.replace(".", ",") : value;

export const isValidRevenueInput = (value: string): boolean =>
  !value.trim() ||
  [canonicalRevenuePattern, groupedRevenuePattern, commaDecimalRevenuePattern].some((pattern) =>
    pattern.test(value.trim()),
  );

export const normalizeRevenueInput = (value: string): string => {
  const trimmed = value.trim();
  if (groupedRevenuePattern.test(trimmed)) {
    return trimmed.replaceAll(".", "").replace(",", ".");
  }
  return commaDecimalRevenuePattern.test(trimmed) ? trimmed.replace(",", ".") : trimmed;
};

export const normalizeRiskDraftValues = <T extends { revenue?: unknown }>(
  formKey: string | undefined,
  values: T,
): T => {
  if (formKey !== "alta-riesgos" && formKey !== "cambios-riesgo") {
    return values;
  }
  const revenue = z.string().safeParse(values.revenue);
  if (!revenue.success || !revenue.data.trim() || !isValidRevenueInput(revenue.data)) {
    return values;
  }
  const normalizedRevenue = normalizeRevenueInput(revenue.data);
  return normalizedRevenue === revenue.data ? values : { ...values, revenue: normalizedRevenue };
};
